/**
 * Mapping of state abbreviations to full state names for inheritance waiver states.
 * These states require specific tax forms (L-8 or ITW) when processing inheritance transfers.
 */
export const stateFullNameMap: Record<string, string> = {
  NJ: 'New Jersey',
  PA: 'Pennsylvania',
};

/**
 * Mapping of state abbreviations to their corresponding inheritance tax form names.
 * - NJ (New Jersey) requires L-8 form
 * - PA (Pennsylvania) requires ITW (Inheritance Tax Waiver) form
 */
export const stateToFormNameMap: Record<string, string> = {
  NJ: 'L-8',
  PA: 'ITW',
};

export const taxUploadOptionsKeys: Record<string, string> = {
  mailingForm: 'mailingForm',
  beneficiarySubmitted: 'beneficiarySubmitted',
  noFormNeeded: 'noFormNeeded',
};

/**
 * Union type representing valid tax upload option keys.
 * Use this type for type-safe access to tax upload option keys.
 */
export type TaxUploadOptionKey = (typeof taxUploadOptionsKeys)[keyof typeof taxUploadOptionsKeys];

export const taxUploadOptionsMap: Record<string, string> = {
  mailingForm: 'You plan on mailing in the form after completing this process',
  beneficiarySubmitted: 'Another beneficiary on the account has submitted the required form',
  noFormNeeded: 'You’ve confirmed you don’t need an inheritance form',
};
